import { ReportStatus } from 'src/api';
import { ReportStatus as ReportStatusGQL } from 'src/graphql';

export const reportStatusToLabel = (
  reportStatus: ReportStatus | ReportStatusGQL,
) => {
  switch (reportStatus) {
    case ReportStatus.READ:
    case ReportStatusGQL.Read:
      return 'Read';
    case ReportStatus.INVESTIGATING:
    case ReportStatusGQL.Investigating:
      return 'Investigating';
    case ReportStatus.CLOSED:
    case ReportStatusGQL.Closed:
      return 'Closed';
    case ReportStatus.DRAFT:
    case ReportStatusGQL.Draft:
      return 'Draft';
    case ReportStatus.LODGED:
    case ReportStatusGQL.Lodged:
      return 'Lodged';
    case ReportStatus.NEW:
    case ReportStatusGQL.New:
      return 'New';
  }
};
